import * as React from 'react';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { SimpleCall, EPageTypes, EPlatformTypes } from '@cian/frontend-newbuilding-call-component';
import { useSelector } from 'react-redux';
import {
  getBuilders,
  getBuildersWithValidPhones,
  getSellers,
  getSellersWithValidPhones,
} from '../../selectors/newbuildingInfo';
import { isLeadFactory } from '../../utils/agent';
import { useApplicationContext } from '../../utils/applicationContext';

export interface ICallButtonProps {
  placeType: string;
  // oxlint-disable-next-line typescript/no-explicit-any
  onShowPhoneClick: (params: any) => void;
  onOpenContactsClick: () => void;
}

export const CallButton: React.FC<ICallButtonProps> = ({ placeType, onShowPhoneClick, onOpenContactsClick }) => {
  const builders = useSelector(getBuilders);
  const buildersWithValidPhones = useSelector(getBuildersWithValidPhones);
  const sellers = useSelector(getSellers);
  const sellersWithValidPhones = useSelector(getSellersWithValidPhones);
  const platformType = EPlatformTypes.WebDesktop;

  const { httpApi, logger } = useApplicationContext();

  if (!httpApi || !logger) {
    return null;
  }

  const phoneStyles = { size: 'XS' as const, beforeIcon: <IconCommunicationPhone16 color="icon-inverted-default" /> };

  const isLeadFactorySeller = sellersWithValidPhones.some(isLeadFactory);
  const hasBuilderWithValidPhones = buildersWithValidPhones.length > 0;
  const phoneButtonText = isLeadFactorySeller
    ? 'Позвонить консультанту'
    : hasBuilderWithValidPhones
      ? 'Контакты застройщика'
      : 'Контакты продавца';

  return (
    <SimpleCall
      httpApi={httpApi}
      logger={logger}
      // @ts-expect-error Ошибка в либе - требует неиспользуемое ей свойство isFichering
      builders={builders}
      sellers={sellers}
      onShowPhoneClick={onShowPhoneClick}
      onOpenContactsClick={onOpenContactsClick}
      openContactsStyles={phoneStyles}
      showPhoneStyles={phoneStyles}
      pageType={EPageTypes.NewbuildingReviews}
      placeType={placeType}
      platformType={platformType}
      singlePhoneButtonText={phoneButtonText}
      multiplePhoneButtonText={phoneButtonText}
    />
  );
};
